import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner"]

  connect() {
  }

  sendTemplate(event) {
    // Mostrar spinner brevemente para feedback visual
    this.showSpinner()

    // Ocultar spinner después de un momento
    setTimeout(() => {
      this.hideSpinner()
    }, 1000)

    // Dejar que el link funcione normalmente (navegación GET)
    return true
  }

  showSpinner() {
    const spinner = document.getElementById('templateSpinner')
    if (spinner) {
      spinner.classList.remove('d-none')
    }
  }

  hideSpinner() {
    const spinner = document.getElementById('templateSpinner')
    if (spinner) {
      spinner.classList.add('d-none')
    }
  }
}
